import Abcjs from './abcjs';
import abcjsLib from 'abcjs';
import { Interval } from '@tonaljs/tonal';
import { Notification } from 'react-bulma-components';
import React from 'react';
import { abcClefModifier, bassClefOctaveShiftSemitones } from '../lib/abcClef';

const Abc = ({ children, ...props }) => {
  var keytonic = props.t;
  let abcnotation = '';
  React.Children.forEach(children, (child) => {
    if (typeof child === 'string') {
      abcnotation += child;
    }
    else{
      abcnotation += `_${child.props.children.join('')}_`;
    }
  });
/*   if(!children){
    children = [];
  } */
  //let abcnotation = children.join(); // "X:1\n\r"+children.join();
  let errormessage=null;
  const found = abcnotation.match(/K:([A-H])/);
  const key = found?found[1]:"C";
  const scoreOffset = Interval.semitones(Interval.distance(key, keytonic));

  // Override whichever clef the source K: line specifies (or defaults to,
  // i.e. treble) with the current instrument's clef, the same way generated
  // notation (abc-notation.js/notes.js) already follows the selected
  // instrument — keeps hand-authored <abc> blocks consistent with it.
  const clefModifier = abcClefModifier(props.clef);
  abcnotation = abcnotation.replace(/^(K:\s*\S+)([^\n\r]*)/m, (match, keyPart, rest) => {
    const restWithoutClef = rest.replace(/\s*clef=\S+/i, '');
    return `${keyPart}${restWithoutClef} ${clefModifier}`;
  });

  // Bass clef sits two octaves lower than treble for the same staff position
  // (see the matching shift in notes.js/abc-notation.js) — apply it here via
  // visualTranspose too, pulled back an octave if it would otherwise push the
  // lowest note under the instrument's practical range.
  let octaveShift = 0;
  if (props.clef === 'f') {
    let pitches = [];
    try {
      const tune = abcjsLib.parseOnly(abcnotation)[0];
      pitches = (tune?.lines || [])
        .flatMap(line => line.staff || [])
        .flatMap(staff => staff.voices || [])
        .flat()
        .filter(el => el.el_type === 'note' && el.pitches)
        .flatMap(el => el.pitches.map(p => p.pitch));
    } catch {
      // Malformed source — fall through with an empty pitch list below.
    }
    octaveShift = bassClefOctaveShiftSemitones(pitches);
  }

  return (
  <Notification color="white" style={{  marginTop: 10, marginBottom: 10 }}>
    {errormessage?<p>{errormessage}</p>:
    <>
      <Abcjs
        abcNotation={abcnotation}
        parserParams={{  }}
        engraverParams={{ responsive: 'resize' }}
        renderParams={{ viewportHorizontal: false, visualTranspose: scoreOffset + octaveShift }}
      />
      </>
    }
  </Notification>
  );
}
export default Abc;